import { Transition } from "@headlessui/react";
import { FormattedMessage as FM } from "react-intl";

import {
  XMarkIcon,
  WarningIcon,
  InfoIcon,
  CheckCircleIcon,
} from "components/Icons";
import { cn } from "tools/ui";

const ICONS = {
  info: <InfoIcon className="h-8 w-8 fill-current text-sky-500" />,
  warning: <WarningIcon className="h-8 w-8 fill-current text-amber-500" />,
  success: <CheckCircleIcon className="h-8 w-8 fill-current text-teal-500" />,
  error: <WarningIcon className="h-8 w-8 fill-current text-rose-500" />,
};

function FormMessage({ message, handleClose }) {
  if (!message.value) return;
  const { type, msg } = message.value;
  let typeMsg = type;
  // success style
  let style = "text-gray-400";
  let msgLabel;
  if (["UserError", "UserWarning"].includes(type)) {
    typeMsg = type.replace("User", "").toLowerCase();
    style = "text-rose-700";
    msgLabel = <p>{msg}</p>;
  } else {
    msgLabel = <FM id={msg} key={msg} />;
  }
  const icon = ICONS[typeMsg];
  if (type === "warning") {
    style = "bg-yellow-100 text-yellow-700";
  } else if (type === "success") {
    style = "text-green-700";
  }

  return (
    <div
      aria-live="assertive"
      className={
        "fixed top-0 bottom-0 right-0 left-0 flex z-99 sm:items-start bg-neutral-800/10 backdrop-blur-xs pt-10"
      }
    >
      <div className="flex w-full flex-col space-y-4 sm:items-center">
        <Transition show={message.value && true}>
          <div className="relative pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg outline-1 outline-black/5 transition data-closed:opacity-0 data-enter:transform data-enter:duration-300 data-enter:ease-out data-closed:data-enter:translate-y-2 data-leave:duration-100 data-leave:ease-in data-closed:data-enter:sm:translate-x-2 data-closed:data-enter:sm:translate-y-0 dark:bg-gray-800 dark:-outline-offset-1 dark:outline-white/10">
            <div className="p-4">
              <div className="flex items-start">
                <div className="shrink-0">{icon}</div>
                <div className="ml-3 w-0 flex-1 pt-0.5">
                  <div className="text-md font-medium text-gray-900 dark:text-white">
                    <FM id={`notification.${typeMsg}`} key={typeMsg} />
                  </div>
                  <div
                    className={cn(
                      "mt-1 text-sm text-gray-500 dark:text-gray-400",
                      style,
                    )}
                  >
                    {msgLabel}
                  </div>
                </div>
                <div
                  className="absolute top-2 right-2 ml-4 flex shrink-0 cursor-pointer active:scale-90 bg-rose-100 rounded-full p-1 text-rose-500"
                  onClick={handleClose}
                >
                  <XMarkIcon
                    aria-hidden="true"
                    className="size-5 fill-current text-gray-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  );
}

export default FormMessage;
